import * as React from 'react';
import { Badge } from '@/components/ui/badge';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';

export function TestDataBadge({ isTestData }: { isTestData?: boolean }) {
  if (!isTestData) return null;
  return <Badge variant="outline">Test data</Badge>;
}

export function TestDataFilterToggle({
  checked,
  onCheckedChange
}: {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}) {
  const id = React.useId();
  return (
    <div className="flex items-center gap-2">
      <Switch id={id} checked={checked} onCheckedChange={onCheckedChange} />
      <Label htmlFor={id} className="text-muted-foreground font-normal">
        Show test data
      </Label>
    </div>
  );
}

export function TestDataStatusControl({
  checked,
  onCheckedChange,
  disabled = false
}: {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
}) {
  const id = React.useId();
  return (
    <div className="flex items-center gap-2">
      <Switch id={id} checked={checked} onCheckedChange={onCheckedChange} disabled={disabled} />
      <Label htmlFor={id} className="font-normal">
        Test/demo record
      </Label>
    </div>
  );
}
